import { useState } from "react";
import { useTranslation } from "react-i18next";
import { MAIN_SITE_URL } from "@/mocks/categories";

const FAQS = [
  { q: "faq1Q", a: "faq1A" },
  { q: "faq2Q", a: "faq2A" },
  { q: "faq3Q", a: "faq3A" },
];

export default function FaqSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="text-center">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            {t("faqH2")}
          </h2>
        </div>

        <div className="mt-8 space-y-3">
          {FAQS.map((faq, i) => {
            const isOpen = openIndex === i;
            return (
              <div
                key={faq.q}
                className="overflow-hidden rounded-lg border border-background-200 bg-white"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="text-sm font-semibold text-foreground-900 md:text-base">
                    {t(faq.q)}
                  </span>
                  <span
                    className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-600 transition-transform ${
                      isOpen ? "rotate-180" : ""
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-base"></i>
                  </span>
                </button>
                {isOpen && (
                  <p className="border-t border-background-100 px-5 py-4 text-sm leading-relaxed text-foreground-600 md:text-base">
                    {t(faq.a)}
                  </p>
                )}
              </div>
            );
          })}
        </div>

        <div className="mt-12 flex flex-col items-center rounded-lg bg-primary-950 px-6 py-12 text-center">
          <h3 className="font-heading text-xl font-bold text-white md:text-2xl">
            {t("finalCtaH2")}
          </h3>
          <p className="mt-3 max-w-xl text-sm text-background-300 md:text-base">{t("finalCtaSub")}</p>
          <div className="mt-6 flex w-full flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="w-full whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold text-white transition-colors hover:bg-primary-600 sm:w-auto"
            >
              {t("finalCtaPrimary")}
            </a>
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="w-full whitespace-nowrap rounded-full border border-white/30 px-7 py-3 text-sm font-semibold text-white transition-colors hover:bg-white/10 sm:w-auto"
            >
              {t("finalCtaSecondary")}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}